export const SDK_VERSION = '7.47.0';
